import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ContactFormSheet from "@/components/sliders/ContactFormSheet";

import {cn} from "@/lib/utils";

interface CTASectionProps {
    title?: string;
    description?: string;
    descriptionClassName?: string;
    primaryButtonText?: string;
    secondaryButtonText?: string;
    secondaryButtonLink?: string;
    showContactForm?: boolean;
    showSecondaryButton?: boolean;
    className?: string;
    backgroundColor?: string;
    variant?: "dark" | "light" | "default";
    
}

const DEFAULT_TITLE = "Ready to Get Started?";
const DEFAULT_DESCRIPTION = "Join hundreds of businesses across New Zealand who trust Harvey Norman Commercial for their technology needs.";
const DEFAULT_DESCRIPTION_CLASSNAME = "";
const DEFAULT_PRIMARY_BUTTON_TEXT = "Contact Us Now";
const DEFAULT_SECONDARY_BUTTON_TEXT = "Visit Showroom";
const DEFAULT_SECONDARY_BUTTON_LINK = "/showroom";
const DEFAULT_SHOW_CONTACT_FORM = true;
const DEFAULT_SHOW_SECONDARY_BUTTON = true;
const DEFAULT_CLASSNAME = "";
const DEFAULT_BACKGROUND_COLOR = "bg-gray-50";

export default function CTAGeneric({
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
    descriptionClassName = DEFAULT_DESCRIPTION_CLASSNAME,
    primaryButtonText = DEFAULT_PRIMARY_BUTTON_TEXT,
    secondaryButtonText = DEFAULT_SECONDARY_BUTTON_TEXT,
    secondaryButtonLink = DEFAULT_SECONDARY_BUTTON_LINK,
    showContactForm = DEFAULT_SHOW_CONTACT_FORM,
    showSecondaryButton = DEFAULT_SHOW_SECONDARY_BUTTON,
    className = DEFAULT_CLASSNAME,
    backgroundColor,
    variant = "default"
}: CTASectionProps) {
    const backgroundClass = backgroundColor ?? (variant === "dark" ? "bg-black text-white" : variant === "light" ? "bg-white" : "bg-gray-50");
    return (
        <section className={`py-8 sm:py-16 ${backgroundClass} ${className}`}>
            <div className="max-w-4xl mx-auto text-center px-4 sm:px-8">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
                    {title}
                </h2>
                <p className={cn("text-sm sm:text-base md:text-lg text-gray-600 mb-6 sm:mb-8 px-4", descriptionClassName)}>
                    {description}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">                    
                    {showContactForm && (
                        <div className="w-full sm:w-auto">
                            <ContactFormSheet buttonText={primaryButtonText} buttonClassName="w-full px-4 sm:px-8 py-2 sm:py-3 text-sm sm:text-lg btn" />
                        </div>
                    )}
                    {showSecondaryButton && (
                        <div className="w-full sm:w-auto">
                            <Link to={secondaryButtonLink} className="w-full">
                                <Button
                                    variant="white"
                                    className="w-full px-4 sm:px-8 py-2 sm:py-3 text-sm sm:text-lg btn"
                                >
                                    {secondaryButtonText}
                                </Button>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
